import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./CourseInquiryForm.module.scss";
import CallbackService, { CallbackData } from "../services/CallbackService";
import { Link } from "react-router-dom";

interface CallbackFormProps {
  onClose: () => void;
  onSubmit: (formData: {
    name: string;
    mobile: string;
    email: string;
    message: string;
  }) => void;
}

const CallbackForm: React.FC<CallbackFormProps> = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState<CallbackData>({
    name: "",
    mobile: "",
    email: "",
    message: "",
    page_url: "",
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      formData.page_url = window.location.href;
      await CallbackService.sendCallback(formData);
      onSubmit(formData); // Optional: Call parent callback if needed
      onClose(); // Close the form after submission
    } catch (err: any) {
      if (err.messages)
        setError(
          "Failed to submit the inquiry. Please try again. \n " +
            JSON.stringify(err.messages)
        );
      else setError("Failed to submit the inquiry. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="modalOverlay" onClick={onClose}></div>
      <div className={styles.modal}>
        <div className={styles.modalContent}>
          <div className={styles.customModalHeader}>
            <button className={styles.closeButton} onClick={onClose}>
              ×
            </button>

            <div className={styles.modalTag}>
              Share your <strong>Problem</strong>
            </div>
            <img
              src="https://images.courseecho.com/svg/google.svg"
              loading="lazy"
              height={28}
              width={28}
              alt="google-expert"
              className={styles.formPic}
            ></img>

            <div className={styles.modalTag}>
              Your request will be evaluated by <strong>Expert</strong>
            </div>
            <img
              src="https://images.courseecho.com/svg/wipro.svg"
              loading="lazy"
              height={28}
              width={28}
              alt="google-expert"
              className={styles.formPic}
            ></img>

            <div className={styles.modalTag}>
              No <strong>Spam</strong> from our side.
            </div>
            <img
              src="https://images.courseecho.com/svg/motherson-summi.svg"
              loading="lazy"
              height={28}
              width={28}
              alt="google-expert"
              className={styles.formPic}
            ></img>

            <div className={styles.modalTag}>
              " Tum mujhe <strong>Issue Do</strong> , Main tumhe{" "}
              <strong>Solution Dunga</strong>"
            </div>
          </div>
          <div className={styles.modalTitle}>
            10K+ experts from 100+ top companies ready to help you
          </div>
          <div className={styles.modalSubTitle}>
            Just mention your problem or{" "}
            <Link to="/book-session/1/" onClick={onClose}>Book Counseling</Link>
          </div>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <div className={styles.itemControl}>
                <div className={styles.itemControlInput}>
                  <div className={styles.itemControlInputContent}>
                    <input
                      type="text"
                      placeholder="Your name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className={styles.input}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.formGroup}>
              <div className={styles.itemControl}>
                <div className={styles.itemControlInput}>
                  <div className={styles.itemControlInputContent}>
                    <input
                      type="text"
                      placeholder="Your phone"
                      name="mobile"
                      maxLength={10}
                      value={formData.mobile}
                      onChange={handleChange}
                      className={styles.input}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.formGroup}>
              <div className={styles.itemControl}>
                <div className={styles.itemControlInput}>
                  <div className={styles.itemControlInputContent}>
                    <input
                      type="email"
                      placeholder="Your email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={styles.input}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.formGroup}>
              <div className={styles.itemControl}>
                <div className={styles.itemControlInput}>
                  <div className={styles.itemControlInputContent}>
                    <textarea
                      name="message"
                      placeholder="Your message"
                      value={formData.message}
                      onChange={handleChange}
                      className={styles.input}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn signupBtn w-50"
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
            {error && <p className={styles.error}>{error}</p>}
          </form>
        </div>
      </div>
    </>
  );
};

export default CallbackForm;
